import React from 'react';
import { Link } from 'react-router-dom';
import './OffUnitMessage.css';

// Why a patient the charge nurse just tapped can't be opened: their room
// isn't on the charge nurse's unit. Says how to fix it (reassign the
// patient) instead of a bare "not found". Shown on the report sheet page and
// inside a phone (`inPhone`, which leaves out the link to the board).
const OffUnitMessage = ({ patientName, room, nurseName, inPhone = false }) => {
  const name = patientName || 'This patient';
  const where = room ? `Room ${room}` : "the patient's room";
  return (
    <div className={`off-unit-error${inPhone ? ' off-unit-error-phone' : ''}`} role="alert">
      <p className="off-unit-error-title">{name} isn't on your unit</p>
      <p>
        You can't open this report sheet because {where} isn't one of your unit's rooms. Reassign {name} to a nurse
        on the unit that has {where}, or ask an admin to correct the room
        {nurseName ? ` or ${nurseName}'s unit` : ''}.
      </p>
      {!inPhone && (
        <Link to="/report-sheets" className="title-button off-unit-error-action">Go to Report Sheets to reassign</Link>
      )}
    </div>
  );
};

export default OffUnitMessage;
